//2025-05-03

import React from "react";
import imagem from "../assets/jump_rope_img.png"

const Treino = (props) => {

  console.log("pathname: " , props.location);
  console.log("id treino: " , props.match.params.id);
  console.log("history: " , props.history);

  const idTreino = props.match.params.id;

  const treino = props.treinos.filter((treino) => treino._id === idTreino);

  console.log("... Treino: ", treino);

  return (
    <main className="content px-2 bg-light">
      {/*<h1>Treino {props.match.params.id}</h1>*/}

      <div className="py-2">      
        <h3>{treino[0] && treino[0].nomeTreino}</h3>
      </div>






      {treino[0] && treino[0].exercicios.map((e) => {
return (
        <div className="row">
          <div className="col-12 col-sm-6 col-xl-4 mb-2">

          <div className="card border-0 shadow">
            <div className="card-body">
              <div className="row d-block d-flex align-items-center">
                {/*<div className="col-6">
                  <img src={imagem} width={50} alt="" />
                </div>*/}
                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-center">
                  <h2 className="fw-extrabold h5">{e.exercicio.name}</h2>
                  {/*<h6>{e.exercicio.name}</h6>*/}
                </div>
              </div>
              <div className="row d-block d-xl-flex align-items-center">
                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                  <p>Número de séries: {e.numSeries}</p>
                </div>
              </div>
              <div className="row d-block d-xl-flex align-items-center">
                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                  <p>Número de repetições: {e.numRepeticoes}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        );
      })
}
  
    </main>
  );
  
};


export default Treino;
